import { Paper } from "@mui/material"
import hljs from "highlight.js/lib/core"
import json from "highlight.js/lib/languages/json"
import "highlight.js/styles/dark.min.css"

import React, { useEffect } from "react"

import { AgentBlueprint } from "../../api/blueprints-api"

hljs.registerLanguage("json", json)

export function BlueprintMetadata(props: { blueprint: AgentBlueprint }) {
  const { blueprint } = props

  useEffect(() => {
    hljs.highlightAll()
  }, [])

  return (
    <Paper sx={{ margin: 0, maxHeight: "calc(100vh - 400px)", overflow: "auto" }} component="pre">
      <code className="language-json">{JSON.stringify(blueprint, null, 2)}</code>
    </Paper>
  )
}
